import { Loan, Task } from '../../../../../../gql/graphql';
import { RulesTasksCards } from '../../../../Dashboard/RulesTaskCards.constanst';
import { calculateLoanProgress } from 'components/Atoms/Progress/LoanProgress/utils/calculateLoanProgress';
import { mapPhaseStateToColor, PhaseState } from '@common/utils/helpers/loanProgress';

/**
 * Calcula el array de progreso (colores por fase) para un loan.
 * Combina RulesTasksCards con loan.tasks y tasks custom, luego usa calculateLoanProgress.
 */
export function getLoanProgress(loan: Loan): any[] {
  const loanDocs = loan.loanDocs || [];

  if (loanDocs.length > 0) {
    const loanSpecificRules: any[] = [];

    // 1. Mapear tasks de RulesTasksCards QUE EXISTEN en loan.tasks
    RulesTasksCards.forEach((rule) => {
      const loanTask = loan.tasks?.find((task: Task) => task.key === rule.key);

      if (loanTask) {
        loanSpecificRules.push({
          key: rule.key,
          modalKey: rule.modalKey,
          name: rule.name,
          filters: rule.filters,
          phase: rule.phase,
          phaseProgress: rule.phaseProgress,
          loanType: rule.loanType,
          loanPurposes: rule.loanPurposes,
          progressButtons: rule.progressButtons,
          state: loanTask.state,
          data: loanTask,
          card: true,
        });
      }
    });

    // 2. Agregar tasks custom creadas desde processing
    const customTasks =
      loan.tasks?.filter(
        (task: Task) => !task.hidden && !task.key // Tasks manuales tienen key: null
      ) || [];

    customTasks.forEach((task) => {
      loanSpecificRules.push({
        key: task._id, // Las tasks manuales usan _id como key
        modalKey: task._id,
        name: task.name || 'Custom Task',
        filters: undefined,
        phase: task.phase ? [task.phase] : ['final'],
        phaseProgress: task.phase || 'final',
        loanType: undefined,
        loanPurposes: undefined,
        progressButtons: undefined,
        state: task.state,
        data: task,
        card: true,
      });
    });

    const phases = calculateLoanProgress(loan, loanSpecificRules, loanDocs);
    return phases.map((phase: { state: string }) => ({
      color: mapPhaseStateToColor(phase.state as PhaseState),
    }));
  }

  return (
    loan.progress?.map((item) => ({
      color: mapPhaseStateToColor(item.state as PhaseState),
    })) || []
  );
}
